import React, { useEffect, useState } from 'react'
import { Modal } from 'semantic-ui-react'
import { AppPrimaryButton, AppSecondaryButton } from 'elements'
import { slugifyListKey } from './utils'
import {
    MasterAnswersFieldGroup,
    MasterAnswersFieldLabel,
    MasterAnswersTextInput,
} from './styles'

export const NewListModal = ({
    open,
    mode = 'create',
    initialName = '',
    initialKey = '',
    saving = false,
    onClose,
    onSave,
}) => {
    const [listName, setListName] = useState('')
    const [listKey, setListKey] = useState('')

    useEffect(() => {
        if (!open) return
        setListName(initialName)
        setListKey(initialKey)
    }, [open, initialName, initialKey])

    const handleSave = () => {
        const name = listName.trim()
        const key =
            listKey.trim() ||
            (mode === 'create' ? slugifyListKey(name) : '')
        onSave({ listName: name, listKey: key })
    }

    return (
        <Modal open={open} onClose={onClose} size="small">
            <Modal.Header>
                {mode === 'create' ? 'New master list' : 'Rename master list'}
            </Modal.Header>
            <Modal.Content>
                <MasterAnswersFieldGroup>
                    <MasterAnswersFieldLabel htmlFor="master-list-display-name">
                        Display name
                    </MasterAnswersFieldLabel>
                    <MasterAnswersTextInput
                        id="master-list-display-name"
                        name="masterListDisplayName"
                        type="text"
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck={false}
                        placeholder="e.g. Customers"
                        value={listName}
                        onChange={e => setListName(e.target.value)}
                    />
                </MasterAnswersFieldGroup>
                <MasterAnswersFieldGroup>
                    <MasterAnswersFieldLabel htmlFor="master-list-key">
                        Key (machine-friendly, unique per tenant)
                    </MasterAnswersFieldLabel>
                    <MasterAnswersTextInput
                        id="master-list-key"
                        name="masterListKey"
                        type="text"
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck={false}
                        placeholder="e.g. customers"
                        value={listKey}
                        disabled={mode === 'rename'}
                        onChange={e => setListKey(e.target.value)}
                    />
                </MasterAnswersFieldGroup>
            </Modal.Content>
            <Modal.Actions>
                <AppSecondaryButton type="button" onClick={onClose}>
                    Cancel
                </AppSecondaryButton>
                <AppPrimaryButton loading={saving} onClick={handleSave}>
                    {mode === 'create' ? 'Create' : 'Save'}
                </AppPrimaryButton>
            </Modal.Actions>
        </Modal>
    )
}
